module.exports = __webpack_public_path__ + "assets/img/icono-email-w.svg";